import { products } from '../../data/products'
import './Products.css'

function ProductCard({ product }) {
  return (
    <article className="product-card" aria-label={product.name}>
      {product.badge && (
        <span className="product-card__badge" aria-label={`${product.badge} item`}>
          {product.badge}
        </span>
      )}

      <div className="product-card__image">
        {product.image ? (
          <img
            src={product.image}
            alt={product.name}
            width="400"
            height="300"
            loading="lazy"
          />
        ) : (
          <div className="product-card__image-placeholder" aria-hidden="true">
            <span>🛍️</span>
            <p>Product Image</p>
          </div>
        )}
      </div>

      <div className="product-card__body">
        <span className="product-card__category">{product.category}</span>
        <h3 className="product-card__title">{product.name}</h3>
        <p className="product-card__desc">{product.description}</p>
        <div className="product-card__footer">
          <span className="product-card__price">{product.price}</span>
          <a
            href={product.purchaseUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="product-card__buy"
            aria-label={`Buy ${product.name} for ${product.price} — opens in new tab`}
          >
            Buy Now
          </a>
        </div>
      </div>
    </article>
  )
}

export default function Products() {
  return (
    <section className="products section" id="products" aria-labelledby="products-heading">
      <div className="container">
        <div className="products__header">
          <span className="products__eyebrow">The Shop</span>
          <h2 className="products__heading" id="products-heading">
            Gear &amp;
            <span className="products__heading-script"> Goodies</span>
          </h2>
          <p className="products__intro">
            Aftercare essentials, gift cards, and exclusive merch — all linked directly
            to our Square store for safe, easy checkout.
          </p>
        </div>

        <div className="products__grid" role="list">
          {products.map((product) => (
            <div role="listitem" key={product.id}>
              <ProductCard product={product} />
            </div>
          ))}
        </div>

        <div className="products__sponsor">
          <p className="products__sponsor-text">Proudly supported by our sponsors</p>
          <img
            src="/images/properbrand.png"
            alt="Proper Brand sponsor logo"
            className="products__sponsor-img"
          />
        </div>
      </div>
    </section>
  )
}